import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=b190f9a4&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=b190f9a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b190f9a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b190f9a4')) {
      api.createRecord('b190f9a4', component.options)
    } else {
      api.reload('b190f9a4', component.options)
    }
    module.hot.accept("./Calendar.vue?vue&type=template&id=b190f9a4&scoped=true", function () {
      api.rerender('b190f9a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/Calendar.vue"
export default component.exports